import { Rule, SameAttributesRule } from '@effectivastudio/smart_collapsed';

// This rules are only applied to event-cards via css selector in smart_collapse initializer

export default [
  // Same card_title + same card_publisher + count > 2
  SameAttributesRule({
    collapseAfter: 2,
    attributes: ['card_title', 'card_publisher'],
  }),

  // Same card_publisher + within 30 minutes period
  new Rule('publisher_and_created_at', (rule, item) => {
    const key = item.attributes.card_publisher;
    const lastResult = rule.index.last(key);
    const length = rule.index.length(key);

    rule.index.push(key, item);

    return length >= 2 && Math.abs(lastResult.attributes.date - item.attributes.date) < Rule.minutes(30);
  }),
];
